import { Dependencies, DependenciesFactory, FileContent, FileContentFactory } from ".."

export interface CreateSurvey {
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    link: string
    startDate: string
    endDate: string
    dependencies: Dependencies | null
}

export class CreateSurveyFactory {
    static create(): CreateSurvey {
        return {
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            descriptions: {
                hr: "",
                en: "",
            },
            image: FileContentFactory.create(),
            link: "",
            startDate: "",
            endDate: "",
            dependencies: DependenciesFactory.create(),
        }
    }
}
